var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.07,
    height: 44.07,
    viewBox: "0 0 44.07 44.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_profile-2user",
    "data-name": "vuesax/linear/profile-2user",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.447,16.287a3.338,3.338,0,0,0-.606,0,8.162,8.162,0,1,1,.606,0Z",
    transform: "translate(8.373 3.672)",
    fill: "none",
    stroke: "#ec1e24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.239,0A6.422,6.422,0,0,1,6.666,6.427,6.436,6.436,0,0,1,.477,12.854a2.074,2.074,0,0,0-.477,0",
    transform: "translate(29.894 7.345)",
    fill: "none",
    stroke: "#ec1e24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.333,2.52c-4.444,2.975-4.444,7.822,0,10.779,5.05,3.379,13.331,3.379,18.381,0,4.444-2.975,4.444-7.822,0-10.779C16.682-.84,8.4-.84,3.333,2.52Z",
    transform: "translate(4.306 24.215)",
    fill: "none",
    stroke: "#ec1e24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,11.017a8.882,8.882,0,0,0,3.6-1.6,4.651,4.651,0,0,0,0-7.841A9.132,9.132,0,0,0,.055,0",
    transform: "translate(33.676 25.707)",
    fill: "none",
    stroke: "#ec1e24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H44.07V44.07H0Z",
    transform: "translate(44.07 44.07) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard1);
export default __webpack_public_path__ + "static/media/dashboard1.71ffb4e745d5902b830de37541539154.svg";
export { ForwardRef as ReactComponent };